const pageNameKey = "logout";

export const logoutEn = {
  [pageNameKey]: {
    signingOutMessage:
      "Just a moment while we smoothly transition you out of the system...",
  },
};

export const logoutPtBr = {
  [pageNameKey]: {
    signingOutMessage: "Saindo...",
  },
};

export const logoutDe = {
  [pageNameKey]: {
    signingOutMessage:
      "Einen Moment bitte, während wir Sie aus dem System abmelden...",
  },
};

export const logoutZhHans = {
  [pageNameKey]: {
    signingOutMessage: "请稍候，我们将顺利地将您退出系统...",
  },
};

export const logoutIt = {
  [pageNameKey]: {
    signingOutMessage: "Ti stiamo disconnettendo dal sistema...",
  },
};

export const logoutEs = {
  [pageNameKey]: {
    signingOutMessage:
      "Un momento mientras te sacamos del sistema sin problemas...",
  },
};

export const logoutNl = {
  [pageNameKey]: {
    signingOutMessage:
      "Een ogenblik geduld terwijl we u soepel uit het systeem loodsen...",
  },
};

export const logoutTr = {
  [pageNameKey]: {
    signingOutMessage:
      "Sizi sorunsuz bir şekilde sistemden çıkarmamıza bir dakika kaldı...",
  },
};
